/*
 * Author: Harper Yan
 * File Created: Sunday, 24-07-21 10:52 pm
 * Last Modified: Tuesday, 25-06-17 06:28 pm, by Ben Zhao
 */

import { useMemo } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';
import { IconType, svgs as icons } from '../icons';
import { IllustrationType, svgs as illustrations } from '../illustrations';
import { LogoType, svgs as logos } from '../logos';
export interface IconProps extends SvgIconProps {
  name: IconType | IllustrationType | LogoType;
  gutter?: boolean;
  innerSvgProps?: SvgIconProps;
}
export const Icon = ({
  name,
  gutter = false,
  innerSvgProps,
  ...svgProps
}: IconProps) => {
  const Svg = useMemo(() => {
    if (name.startsWith('Illus')) {
      return illustrations[name as IllustrationType];
    }
    if (name.startsWith('Logo')) {
      return logos[name as LogoType];
    }
    return icons[name as IconType];
  }, [name]);
  return <SvgIcon inheritViewBox sx={{
    padding: gutter ? '2px' : '0'
  }} {...svgProps} data-sentry-element="SvgIcon" data-sentry-component="Icon" data-sentry-source-file="index.tsx">
      <Svg {...innerSvgProps} data-sentry-element="Svg" data-sentry-source-file="index.tsx" />
    </SvgIcon>;
};